module.exports = __webpack_public_path__ + "static/media/device-quiz.881ab203.png";